import React, { useEffect, useState } from "react";
import { Box, Grid, useTheme, useMediaQuery, Tooltip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import HeadingComponent from "../../../component/atom/Headings/Heading";
import { QuizAttemptCard } from "../../../component/molecule";
import { TextIconButtonComponent, IconButtonComponent } from "../../../component/atom";
import { connect } from "react-redux";
import { Actions } from "../../../core/modules/Actions";
import moment from "moment";
import _ from "lodash";
import { USER_ROLE, navigateToQuizWithBreadcrumb } from "../../../core/Constant";
import { BarChart, LineChart } from "@mui/x-charts";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";

const valueFormatter = (value) => {
  return `${value} %`
};

const chartSetting = {
  yAxis: [
    {
      label: 'Marks (%)',
    },
  ],
  series: [{ dataKey: 'marks', label: 'Marks', color: '#9834F076', valueFormatter }],
};

const colorPalette = ['#00b5ad', '#2196f3', '#ab47bc', '#ff9800', '#4caf50', '#e91e63'];

const QuizAttemptScreen = ({ stdgetquizAttempts, attemptsData }) => {
  const navigate = useNavigate();
  const [newquiz, setQuiz] = useState('');
  const [attempts, setAttempts] = useState([]);
  const location = useLocation();
  const [userType, setUserType] = useState(1);
  const [newList, setNewList] = useState([]);
  const [series, setSeries] = useState([]);
  const [xLabels, setXLabels] = useState([]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); 

  useEffect(() => {
    getUserType()
  }, []);

  const getUserType = async () => {
    const type = localStorage.getItem('userType');
    setUserType(type)
  };


  useEffect(() => {
    const qId = location.state?.quiz;
    setQuiz(qId)
    stdgetquizAttempts(qId?.id);
  }, [location]);

  useEffect(() => {
    setAttempts(attemptsData)
    const list = _.orderBy(attemptsData, ['attempts'], ['asc']);
    const result = _.map(list, item => {
      return { attempt: item?.attempts, marks: parseFloat(item?.marks) }
    });
    setNewList(result);
    const dataAttempt = _.filter(list, i => i?.category_results?.length > 0);
    const attemptsLabels = _.map(dataAttempt, i => i?.attempts);

  const allCategories = _.uniq(
    _.flatMap(dataAttempt, item =>
      item.category_results.map(cat => cat.category_name)
    )
  );

  const dataSet = allCategories.map((category, index) => {
    const data = dataAttempt.map(attempt => {
      const found = attempt.category_results.find(
        cat => cat.category_name === category
      );
      return found ? Number(found.marks) : null;
    });
      const formattedLabel = category.length > 10 ? `${category.substring(0, 10)}...` : category;

    return {
      label: formattedLabel,
        fullLabel: category,
      data,
        color: colorPalette[index % colorPalette.length]
    };
  });

    setSeries(dataSet);
    setXLabels(attemptsLabels);
  }, [attemptsData]);

  const onViewAttemptForm = (id, user, quizid, name, attempt) => {
    navigate('/quiz-attempt-form', {state: { quiz_status_id: id, user_id: user, quiz_id: quizid, quiz_name: name, attempt } });
  }

 const handleBackClick = () => {
  if (userType === USER_ROLE.admin) {
    navigate(-1);
  } else {
      navigateToQuizWithBreadcrumb(navigate, location);
    }
  };

  return (
    <Box
      className="main-screen-container"
      sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
      <Box display="flex" justifyContent={"space-between"}>
              <IconButtonComponent
                onclick={handleBackClick}
                btnType="backbtn"
                btnText="Back"
              />
      </Box>

      <Box display="flex" alignItems="center" justifyContent="space-between">
                <p className="quiz-attempt-subtext">{newquiz?.name}</p>
              </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {attemptsData.length === 0 ? (
          <p>
            No data found <br /> Attempt again
          </p>
        ) : (
          attempts.map((item, index) => (
            <Box key={`attempt${index}`} width="100%">
              <QuizAttemptCard
                itemData={item}
                index={attempts?.length - index}
                onButtonClick={() =>
                  onViewAttemptForm(
                    item.id,
                    item.user_id,
                    item.quiz_id,
                    newquiz?.name,
                    item?.attempts,
                  )
                }
                attempt={item.attempts}
                time={moment(
                  new Date(_.get(item, "finished_at", new Date())),
                ).format("hh:mm a")}
                date={moment(
                  new Date(_.get(item, "finished_at", new Date())),
                ).format("Do MMM YYYY")}
                marks={item.marks}
              />
            </Box>
          ))
        )}
      </Box>

      {/* Quiz Header & Action */}
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <p 
          className="quiz-attempt-subtext" 
          style={{ fontSize: "22px", fontWeight: 600, margin: 0 }}
        >
          Quiz Graph Progress
        </p>
              <TextIconButtonComponent
                buttonStyleClass="btn btn-primary"
                btnText={"Show Result In Graph"}
                icon={faChartLine}
                onclick={() => navigate('/quiz-attempt-result', {state: { quiz: location?.state?.quiz },
            })
          }
        />
      </Box>

      {/* Side-by-Side Charts Row */}
      {(newList?.length > 0 || xLabels?.length > 0) && (
        <Grid container spacing={2} sx={{ width: "100%", mb: 4 }}>
          {/* Bar Chart Grid Item */}
      {newList?.length > 0 && (
        <Grid item xs={12} md={6}>
          <Box
                sx={{
                  width: "100%",
                  overflowX: "auto",
                  display: "flex",
                  justifyContent: "center",
                  p: 1,
                  bgcolor: "#fff",
                }}
              >
                      <BarChart
                        xAxis={[{ scaleType: 'band', dataKey: 'attempt', label: "Attempts" }]}
                        dataset={newList}
                        {...chartSetting}
                        width={isMobile ? 320 : 480}
                        height={350}
                        margin={{ top: 40, bottom: 50, left: 60, right: 20 }}
                      />
                  </Box>
                </Grid>
      )}

          {/* Line Chart Grid Item */}
      {xLabels?.length > 0 && (
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              width: "100%",
              overflowX: "auto",
              display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  p: 1,
                  bgcolor: "#fff",
            }}
          >
                        <LineChart
                          width={isMobile ? 340 : 480}
                          height={350}
                          series={series}
                          xAxis={[
                            {
                              scaleType: 'point',
                              dataKey: 'attempts',
                              data: xLabels,
                              tickPlacement: 'middle',
                              tickLabelPlacement: 'middle',
                              label: 'Attempts',
                              tickLabelFormatter: (label) => {
                                if (typeof label === 'string' && label.length > 8) {
                                  return label.match(/.{1,8}/g).join('\n');
                                }
                                return label;
                              },
                              tickLabelStyle: {
                                fontSize: 12,
                                whiteSpace: 'pre-line',
                                wordBreak: 'break-word',
                                maxWidth: 60,
                                textAlign: 'center',
                              },
                            },
                          ]}
                          yAxis={[{ label: 'Marks' }]}
                  slots={{ legend: () => null }}
                  margin={{ top: 40, bottom: 50, left: 50, right: 30 }}
                />

                <Box
                  display="flex"
                  flexWrap="wrap"
                  gap={2}
                  justifyContent="center"
                  mt={1}
                  px={2}
                >
                  {series.map((item, idx) => (
                    <Tooltip key={`custom-legend-${idx}`} title={item.fullLabel} arrow placement="top">
                      <Box display="flex" alignItems="center" gap={0.8} sx={{ cursor: 'pointer' }}>
                        <Box
                          sx={{
                            width: 12,
                            height: 12,
                            backgroundColor: item.color,
                            borderRadius: '2px',
                          }}
                        />
                        <span style={{ fontSize: '12px', color: '#555', fontWeight: 500 }}>
                          {item.label}
                        </span>
                      </Box>
                    </Tooltip>
                  ))}
                  </Box>
            </Box>
            </Grid>
          )}
        </Grid>
        )}
      </Box>
  );
}

export default connect(state => ({
  attemptsData: state.quizes.get('attemptsData'),
  startData: state.quizes.get('startData')
}),
  {
    stdgetquizAttempts: Actions.quizes.stdgetquizAttempts,
  }
)(QuizAttemptScreen);
